import styled, { keyframes } from "styled-components";

export interface StyledLinearLoaderProps {
  $height: number;
  $activeStrokeColor: string;
  $inactiveStrokeColor: string;
  $activeColorPercentage: "25%" | "50%" | "75%";
  $animationDuration: number;
}

const moveLineAnimation = (percentage: "25%" | "50%" | "75%") => keyframes`
  0% {
    transform: translateX(${
      percentage === "25%" ? "-110%" : percentage === "50%" ? "-70%" : "-55%"
    });
  }
  100% {
    transform: translateX(${
      percentage === "25%" ? "400%" : percentage === "50%" ? "220%" : "200%"
    });
  }
`;

export const StyledLinearLoader = styled.div<StyledLinearLoaderProps>`
  width: 100%;
  height: ${(props) => props.$height}px;
  position: relative;
  overflow: hidden;
  background-color: ${(props) => props.$inactiveStrokeColor};
  border-radius: ${(props) => props.$height}px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    border-radius: ${(props) => props.$height}px;
    left: 0;
    width: ${(props) => props.$activeColorPercentage};
    height: 100%;
    background-color: ${(props) => props.$activeStrokeColor};
    animation: ${(props) => moveLineAnimation(props.$activeColorPercentage)}
      ${(props) => props.$animationDuration}s infinite linear;
  }
`;

StyledLinearLoader.displayName = "StyledLinearLoader";
